export default __webpack_public_path__ + "static/media/Captain+Avatar.c9034bb5.png";